exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-card-grid[data-v-35cc6fd1]{list-style:none;margin:.5rem 0;padding:0;display:flex;align-items:flex-start;flex-wrap:wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35cc6fd1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/imagehandling/flickr-button.vue
// module id = 1967
// module chunks = 0